export default __webpack_public_path__ + "static/media/unknow-user.904bd187.svg";